import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { instanceAPIPrivate } from 'config/axiosconfig';

const axiosConfig = {
  withCredentials: true,
};

export const hasSuscripted = createAsyncThunk(
  'suscripted',
  async (id) => {
    const suscripted = await instanceAPIPrivate.post('/verify-suscription', id, axiosConfig)
      .then((resp) => resp.data)
      .catch((err) => err.response.data);
    return suscripted;
  },
);

const hasSuscriptedSlice = createSlice({
  name: 'suscripted',
  initialState: {
    suscripted: false,
    suscriptedStatus: '',
  },
  extraReducers: {
    [hasSuscripted.pending]: (state) => {
      state.suscriptedStatus = 'loading';
    },
    [hasSuscripted.fulfilled]: (state, action) => {
      state.suscriptedStatus = 'success';
      state.suscripted = action.payload;
    },
    [hasSuscripted.rejected]: (state) => {
      state.suscriptedStatus = 'failed';
    },
  },
});

export default hasSuscriptedSlice.reducer;
